import { store } from '../../../../store/store';

export default {
  connectUser
};

function connectUser(state) {
  const { getWorkPlaceId, getCallBrandList, agentId, telNumber, name } = store.getters;
  const connectMsg = {
    workPlacesId: getWorkPlaceId,
    brands: getCallBrandList.map((m) => m.brandId) || [],
    agentId: agentId,
    agentName: name,
    extension: telNumber,
    sendType: 'regi',
    data: {
      viewType: 'call',
      availRecv: []
    }
  };
  store.commit('sendMessageToStatusSocket', JSON.stringify(connectMsg));
}



// WEBPACK FOOTER //
// ./src/util/call/kt/ktAPI/statusEvent.js